import { SET_FILTER_VALUE, SET_PAGE, SET_PAGE_SIZE, SET_SORTED, SET_COLUMNS, SET_EDITED_ROW } from './types';
export const setFilterValue = (filterValue, resetPage = false) => ({
  type: SET_FILTER_VALUE,
  filterValue,
  resetPage
});
export const setPage = page => ({
  type: SET_PAGE,
  page
});
export const setPageSize = (pageSize, resetPage = false) => ({
  type: SET_PAGE_SIZE,
  pageSize,
  resetPage
});
export const setSorted = (sorted, resetPage = false) => ({
  type: SET_SORTED,
  sorted,
  resetPage
});
export const setColumns = columns => ({
  type: SET_COLUMNS,
  columns
});
export const setEditedRow = rowId => ({
  type: SET_EDITED_ROW,
  rowId
});